import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

import { LogoutButton } from "./logoutButton";
export const UnAuthorized = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <Card>
        <CardHeader>
          <CardTitle className="text-center">Unauthorized</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col space-y-4 items-center text-center">
          <p className="text-lg text-gray-500 pb-4">
            You do not have permission to view the Operations Panel. Please contact your administrator to request access.
          </p>
          <LogoutButton size={20} />
        </CardContent>
      </Card>
    </div>
  );
};
